export default __webpack_public_path__ + "static/media/addnew-icon1.37122c7e.svg";